/* eslint-disable prettier/prettier */
// WARNING: prettier is intentionally disabled to ensure code formatting doesn't break `import.meta.env` refs

/**
 * Statically returns all known environment variables in a single place to prevent issues with
 * code formatting (e.g. line breaks) potentially breaking the static replacement of runtime variables
 * during build.
 * 
 * This is necessary to adhere to their [special expression](https://import-meta-env.org/guide/getting-started/introduction.html#special-expression).
 * 
 * WARNING: If variables are not statically referenced, their links to runtime envs might silently break
 * when the App gets built and deployed.
 * 
 * @see {@link https://e-pilot.atlassian.net/browse/ER-4839}
 */
export const loadEnvs = () => {
  return {
    // runtime variables
    VITE_JOURNEY_APP_BASE_URL: import.meta.env.VITE_JOURNEY_APP_BASE_URL,
    VITE_EMBED_URL: import.meta.env.VITE_EMBED_URL,
  }
}

/**
 * Since {@link loadEnvs} should result in the same on every call, this keeps track of its cached result
 * after the initial call, which is fully managed in {@link env}.
 */
let cachedEnvs: ReturnType<typeof loadEnvs>

/**
 * Returns the value of a given environment variable key.
 * 
 * NOTE: For safety, always use this method to access environment variables
 * instead of directly referencing `import.meta.env`. See {@link loadEnvs}
 * for more information.
 */
export function env<K extends keyof ReturnType<typeof loadEnvs>>(key: K) {
  if (!cachedEnvs) cachedEnvs = loadEnvs()

  return cachedEnvs[key]
}